const Index = () => import(/* webpackChunkName: "manager" */ './Index');
const Personal = () => import(/* webpackChunkName: "personal" */ './Personal');

import Rept from '@/components/book/rept/router'

export default {
    routes: [
        {
            path: '/book/index',
            name: 'book_index',
            component: Index
        },
        {
            path: '/book/personal',
            name: 'book_personal',
            component: Personal
        },
        ...Rept.routes
    ]
}
